import { axiosAlertInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import {
  ALL_MARKET,
  ALL_OPERATOR,
  ALL_PROVIDER,
} from '@/constant/global/global.constant';
import {
  EAlertLevels,
  EAlertStatus,
  EAlertType,
} from '@/constant/alerts/alerts.constant';
import { IFetchAlerts, IAlert } from './alerts.type';
import { EALERT_LIFECYCLE } from './alerts.constants';

// Define the Location interface representing the structure of the user object returned by the API

export const fetchAlerts = ({
  page,
  limit,
  operatorId,
  triggeredOn,
  level,
  startDate,
  endDate,
  type,
  order,
  orderBy,
  triggeredStartDate,
  triggeredEndDate,
  status,
  isCompressed,
  alertId,
  marketId,
  provider,
}: IFetchAlerts): Promise<AxiosResponse<IAlert[], any>> => {
  return axiosAlertInstance({
    url: API_URL_CONFIG.ALERT.GET_ALERTS,
    params: {
      page,
      limit,
      ...(operatorId !== ALL_OPERATOR.id ? { operatorId } : {}),
      ...(provider !== ALL_PROVIDER.id ? { provider } : {}),
      ...(marketId !== ALL_MARKET.id ? { marketId } : {}),
      ...(type !== EAlertType[0].id ? { type } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(order ? { order } : {}),
      ...(orderBy ? { orderBy } : {}),
      ...(level !== EAlertLevels[0].id ? { level } : {}),
      ...(status !== EAlertStatus[0].id ? { status } : {}),
      ...(triggeredOn ? { triggeredOn } : {}),
      ...(triggeredStartDate ? { triggeredStartDate } : {}),
      ...(triggeredEndDate ? { triggeredEndDate } : {}),
      ...(alertId ? { alertId } : {}),
      isCompressed,
    },
  });
};

export const fetchAlertById = (
  alertId: string,
): Promise<AxiosResponse<IAlert[], any>> => {
  return axiosAlertInstance.get(
    `${API_URL_CONFIG.ALERT.GET_ALERTS}/${alertId}?isCompressed=false&isErrorsIncluded=true&lifecycle=${EALERT_LIFECYCLE.FULL}`,
  );
};
